import Channels from './components/Channels';

export default Channels;
